/* globals FACEBOOK_APP_ID, WEB_ROOT */

import React, { PropTypes } from 'react';

import ExternalLink from '../../ExternalLink';
import ExternalBookingButton from '../ExternalBookingButton';
import HeartButton from '../../../containers/HeartButton';

import {
  actions,
  button,
  heartButton,
  shareButton,
  shareIcon,
  shareText,
} from './styles.module.css';

/**
 * Actions
 */
const Actions = ({
  id,
  onShare,
  organiser,
  permalink,
  races,
  startDate,
  title,
}) => (
  <div className={actions}>
    <div>
      <HeartButton
        key={id}
        id={id}
        className={[heartButton, button].join(' ')}
        noTooltip
        black
        trackingObject={{
          id,
          title,
          organiser,
          startDate,
        }}
        showText
      >
        <div className="heart" aria-hidden="true" />
      </HeartButton>
    </div>
    <div>
      <ExternalLink
        className={shareButton}
        onClick={() => onShare('facebook')}
        href={`https://www.facebook.com/dialog/share?app_id=${FACEBOOK_APP_ID}&href=${encodeURIComponent(
          `${WEB_ROOT}${permalink}?utm_source=facebook&utm_medium=social&utm_campaign=event_share`,
        )}&redirect_uri=${encodeURIComponent(`${WEB_ROOT}${permalink}`)}`}
      >
        <div className={shareIcon} aria-hidden="true" />
        <div className={shareText}>{'Share'}</div>
      </ExternalLink>
    </div>
    <div>
      <ExternalBookingButton className={shareButton} races={races} eventId={id} />
    </div>
  </div>
);

Actions.propTypes = {
  id: PropTypes.number.isRequired,
  onShare: PropTypes.func,
  organiser: PropTypes.shape(),
  permalink: PropTypes.string,
  races: PropTypes.shape(),
  startDate: PropTypes.string,
  title: PropTypes.string.isRequired,
};

Actions.defaultProps = {
  onShare: () => {},
  organiser: null,
  permalink: null,
  races: undefined,
  startDate: null,
};

export default Actions;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/Actions/index.jsx